export const ROOT_CONTAINER_ID = 'root';
export const root = document.getElementById(ROOT_CONTAINER_ID);
